import React from 'react';
import { FaPaintRoller, FaHome, FaChartLine } from 'react-icons/fa';

const Renovation = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6 text-center text-green-600">Servicios de Renovación</h1>

      <div className="grid md:grid-cols-2 gap-8 items-center mb-12">
        <div className="flex justify-center">
          <FaHome className="text-green-500 w-64 h-64" />
        </div>
        <div>
          <h2 className="text-2xl font-semibold mb-4">Renueva y Transforma tu Espacio</h2>
          <p className="text-gray-700 mb-4">
            Nuestro equipo de renovación está especializado en dar nueva vida a espacios existentes. 
            Ya sea una cocina anticuada, un baño que necesita actualización o una remodelación completa del hogar, 
            estamos aquí para hacer realidad tu visión.
          </p>
          <ul className="list-disc list-inside text-gray-700">
            <li>Remodelación de cocinas y baños</li>
            <li>Ampliaciones y modificaciones estructurales</li>
            <li>Actualización de sistemas eléctricos y de plomería</li>
            <li>Mejoras de eficiencia energética</li>
          </ul>
        </div>
      </div>

      <div className="bg-gray-100 p-8 rounded-lg shadow-md">
        <h3 className="text-xl font-semibold mb-4">Beneficios de la Renovación</h3>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="text-center">
            <FaPaintRoller className="mx-auto text-green-500 w-12 h-12 mb-2" />
            <h4 className="font-semibold mb-2">Estética Mejorada</h4>
            <p className="text-sm text-gray-600">Actualiza el aspecto de tu espacio</p>
          </div>
          <div className="text-center">
            <FaHome className="mx-auto text-green-500 w-12 h-12 mb-2" />
            <h4 className="font-semibold mb-2">Mayor Comodidad</h4>
            <p className="text-sm text-gray-600">Mejora la funcionalidad de tu hogar</p>
          </div>
          <div className="text-center">
            <FaChartLine className="mx-auto text-green-500 w-12 h-12 mb-2" />
            <h4 className="font-semibold mb-2">Aumento de Valor</h4>
            <p className="text-sm text-gray-600">Incrementa el valor de tu propiedad</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Renovation;